<template>
	<div>
		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					:disable="this.status == 2 ? false : true"
					color="positive"
					class="full-width"
					:label="$t('publish')"
					icon="far fa-upload"
					@click="confirm_publish = true"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					:disable="this.status == 1 ? false : true"
					color="info"
					class="full-width"
					:label="$t('close_campaign')"
					icon="far fa-check"
					@click="confirm_close = true"
				/>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'campaigns' })"
				/>
			</div>
		</div>

		<q-dialog v-model="confirm_publish" @ok="publishCampaign">
			<span slot="title">{{ $t('publish_campaign') }}</span>

			<span slot="message">{{ $t('are_your_sure_you_want_to_publish_the_campaign') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="confirm_publish = false" />
				<q-btn color="negative" :label="$t('publish')" @click="publishCampaign()" />
			</template>
		</q-dialog>

		<q-dialog v-model="confirm_close" @ok="finishCampaign">
			<span slot="title">{{ $t('close_campaign') }}</span>

			<span slot="message">{{ $t('are_your_sure_you_want_to_close_the_campaign') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="confirm_close = false" />
				<q-btn color="negative" :label="$t('close_campaign')" @click="finishCampaign()" />
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
	name: 'Configure-and-Publish',

	data() {
		return {
			confirm_publish: false,
			confirm_close: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id: 'campaigns/id',
			status: 'campaigns/status',
			title: 'campaigns/title',
			sub_title: 'campaigns/sub_title',
			description: 'campaigns/description',
			campaign_url: 'campaigns/campaign_url',
			image: 'campaigns/image',
			area: 'campaigns/areas',
			profile: 'campaigns/profiles',
			start_date: 'campaigns/start_date',
			end_date: 'campaigns/end_date',
			company_branches: 'campaigns/company_branches',
			brands: 'campaigns/brands',
			product_types: 'campaigns/product_types',
			products: 'campaigns/products',
			rewards: 'campaigns/rewards',
			allow_sells: 'campaigns/allow_sells',
			training_kpi_points: 'campaigns/training_kpi_points',
			training_non_kpi_points: 'campaigns/training_non_kpi_points',
			error_company_branches: 'campaigns/error_company_branches',
			error_brands: 'campaigns/error_brands',
			error_product_types: 'campaigns/error_product_types',
			error_products: 'campaigns/error_products',
			error_rewards: 'campaigns/error_rewards',
			image_banner: 'campaigns/image_banner',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		publishCampaign() {
			if (this.company_branches.length == 0)
				this.$store.dispatch('campaigns/SET_ERROR_COMPANY_BRANCHES', [true])
			else this.$store.dispatch('campaigns/SET_ERROR_COMPANY_BRANCHES', [false])

			if (this.brands.length == 0 && this.allow_sells)
				this.$store.dispatch('campaigns/SET_ERROR_BRANDS', [true])
			else this.$store.dispatch('campaigns/SET_ERROR_BRANDS', [false])

			if (this.product_types.length == 0 && this.allow_sells)
				this.$store.dispatch('campaigns/SET_ERROR_PRODUCT_TYPES', [true])
			else this.$store.dispatch('campaigns/SET_ERROR_PRODUCT_TYPES', [false])

			if (this.products.length == 0 && this.allow_sells)
				this.$store.dispatch('campaigns/SET_ERROR_PRODUCTS', [true])
			else this.$store.dispatch('campaigns/SET_ERROR_PRODUCTS', [false])

			if (this.rewards.length == 0)
				this.$store.dispatch('campaigns/SET_ERROR_REWARDS', [true])
			else this.$store.dispatch('campaigns/SET_ERROR_REWARDS', [false])

			if (
				!this.error_company_branches &&
				!this.error_brands &&
				!this.error_product_types &&
				!this.error_products &&
				!this.error_rewards
			) {
				this.$store.dispatch('campaigns/SET_STATUS', [1])
				this.saveData()
			} else {
				this.messageValidate()
				this.confirm_publish = false
			}
		},

		finishCampaign() {
			this.$store.dispatch('campaigns/SET_STATUS', [4])
			this.saveData()
		},

		saveData() {
			let data = {
				title: this.title,
				sub_title: this.sub_title,
				description: this.description,
				campaign_url: this.campaign_url,
				start_date: moment(this.start_date).format('YYYY-MM-DD'),
				end_date: moment(this.end_date).format('YYYY-MM-DD'),
				image: this.image,
				image_banner: this.image_banner,
				areas: this.area,
				profiles: this.profile,
				status: this.status,
				company_branches: this.company_branches,
				brands: this.brands,
				product_types: this.product_types,
				products: this.products,
				rewards: this.rewards,
				allow_sells: this.allow_sells,
				training_kpi_points: this.training_kpi_points,
				training_non_kpi_points: this.training_non_kpi_points,
			}

			this.$axios
				.put(`/admin_rewards/campaigns/${this.id}/`, data, this.getHeader)
				.then(() => {
					this.$q.notify({
						message: this.$t('basic_data_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
					this.$router.push({ name: 'campaigns' })
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('basic_data_save_error'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		messageValidate() {
			this.$q.notify({
				message: this.$t('make_sure_that_all_fields_are_filled_in'),
				type: 'negative',
				icon: 'fal fa-exclamation-triangle',
				position: 'top',
			})
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},
	},
}
</script>

<style></style>
